import styled from '@emotion/styled'
import React from 'react'

import { NativeLink, palette, Text } from 'main/ui'
import { useTranslation } from 'react-i18next'
import { LOCIZE_NAMESPACE } from '../../../common'

const StyledText = styled(Text)`
  color: ${palette.slate};
  font-size: 14px;
`
const PRE = `COMPONENTS-MENU-HEADER-SUPPORT-PHONE-LINK`

export default function SupportPhoneLink() {
  const { t } = useTranslation(LOCIZE_NAMESPACE)

  return (
    <StyledText>
      {t(`${PRE}-TEXT`)}{' '}
      <NativeLink href="mailto: hello@wonderschool.com">hello@wonderschool.com</NativeLink>
    </StyledText>
  )
}
